module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-lighting@2x.png?5a4e9ad4d6947bba2cedab47ed4e7d25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-lighting@2x.png
// module id = 1038
// module chunks = 1